import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "icon" }

import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

import AddDecisionModal from '@/components/AddDecisionModal.vue';
import { Litigation } from '@/Litigation/litigation.entity';


export default /*#__PURE__*/_defineComponent({
  __name: 'DecisionButtonAdd',
  props: {
    litigation: {}
  },
  emits: ["success"],
  setup(__props: any, { emit }) {




const { t } = useI18n();
const open = ref(false);

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("span", null, [
    _createVNode(_component_el_button, {
      class: "button is-primary is-radius-small has-text-weight-semibold",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (open.value = true))
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_1, [
          _createVNode(_component_font_awesome_icon, { icon: "file-import" })
        ]),
        _createElementVNode("span", null, _toDisplayString(_unref(t)('listAnalyses.addDecision')), 1)
      ]),
      _: 1
    }),
    (open.value)
      ? (_openBlock(), _createBlock(AddDecisionModal, {
          key: 0,
          litigation: _ctx.litigation,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (open.value = false)),
          onSuccess: _cache[2] || (_cache[2] = ($event: any) => (emit('success')))
        }, null, 8, ["litigation"]))
      : _createCommentVNode("", true)
  ]))
}
}

})